import { render } from "./cierrecaja.vue?vue&type=template&id=1745f0b2&scoped=true"
import script from "./cierrecaja.vue?vue&type=script&lang=js"
export * from "./cierrecaja.vue?vue&type=script&lang=js"

import "./cierrecaja.vue?vue&type=style&index=0&id=1745f0b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1745f0b2"]])

export default __exports__